import React from 'react';
import HeaderOne from "../common/header/HeaderOne";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import AboutFour from '../components/about/AboutFour';
import WorkPerformanceOne from '../components/work-performance/WorkPerformanceOne';
import FeatureFour from '../components/features/FeatureFour';
import ProjectThree from '../components/project/ProjectThree';
import FooterOne from '../common/footer/FooterOne';

const AboutOne = () => {
    return (
        <>
            <HeaderOne />
            <Breadcrumb 
                heading="About Us"
                currentPage="About Us" 
            />
            <AboutFour />
            <WorkPerformanceOne />
            <FeatureFour />
            <ProjectThree />
            <FooterOne />
        </>
    )
}

export default AboutOne;
